import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  increment,
  counter,
  moamad,
  rltvOptions,
  departmentsList,
}) {
  const [newRltv, setNewRltv] = useState({
    full_name: "",
    idz: "",
    rltv_type: "",
    job: "",
    department: 0,
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewRltv((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setNewRltv((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "relative/",
          newRltv,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              הקירבה של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <Row>
                    <Col>
                      <div className="form-cgroup">
                        <label htmlFor="full_name">שם הקרוב </label>
                        <input
                          type="text"
                          name="full_name"
                          className="form-control"
                          id="full_name"
                          value={newRltv.full_name}
                          placeholder="תקליד שם קרוב המשפחה"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="idz"> ת"ז </label>
                        <input
                          type="number"
                          name="idz"
                          className="form-control"
                          id="idz"
                          value={newRltv.idz}
                          placeholder="תקליד תז של הקרוב"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="job">תפקיד</label>
                        <input
                          type="text"
                          name="job"
                          className="form-control"
                          id="job"
                          value={newRltv.job}
                          placeholder="תקליד  תפקיד "
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <br></br>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="rltv_type">בחר סוג הקירבה</label>
                        <select
                          name="rltv_type"
                          onChange={handleChange}
                          value={newRltv.rltv_type}
                          required
                        >
                          <option key="0" value="" selected>
                            בחר סוג
                          </option>
                          {rltvOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                      <br></br>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="department">מחלקה</label>
                        <br />
                        <select
                          name="department"
                          onChange={handleDDSChange}
                          value={newRltv.department}
                        >
                          <option value="" selected>
                            בחר מחלקה
                          </option>
                          {departmentsList?.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <label>
                    {" "}
                    <span
                      style={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      בשדה מחלקה:
                    </span>{" "}
                    -במקרה שקרוב המשפחה הוא נבחר ציבור נא לבחור{" "}
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      במועצת הרשות -נבחרים
                    </span>
                  </label>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
